import { NewAddressData } from "../../../../core/models/managementsUpdate/managementUpdateAddress/managementUpdateAddress.model";

const initialNewAddressData = {
  province: "",
  municipality: "",
  city: "",
  streetType: "",
  address: "",
  zip: "",
  number: 0,
  supplementary: "",
};

const formatUpdateShippingAddressRequestBody = (
  cupsCode: string,
  name: string,
  {supplementary, zip, address, number, streetType }: NewAddressData
) => ({
    codigoCups: cupsCode,
    nombre: name,
    idCiudad: "",
    codigoPostal: zip,
    calle: address,
    codigoTipoVia: streetType,
    numero: number,
    aclarador: supplementary,
});

export { initialNewAddressData, formatUpdateShippingAddressRequestBody };
